@file:OptIn(InternalResourceApi::class)

package mobile_wallet.feature.editpassword.generated.resources

import kotlin.OptIn
import kotlin.String
import kotlin.collections.MutableMap
import org.jetbrains.compose.resources.InternalResourceApi
import org.jetbrains.compose.resources.LanguageQualifier
import org.jetbrains.compose.resources.ResourceItem
import org.jetbrains.compose.resources.StringResource

private const val MD: String =
    "composeResources/mobile_wallet.feature.editpassword.generated.resources/"

internal val Res.string.feature_editpassword_cancel: StringResource by lazy {
      StringResource("string:feature_editpassword_cancel", "feature_editpassword_cancel", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 10, 47),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 10, 43),
      ))
    }

internal val Res.string.feature_editpassword_change_password: StringResource by lazy {
      StringResource("string:feature_editpassword_change_password", "feature_editpassword_change_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 58, 72),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 54, 64),
      ))
    }

internal val Res.string.feature_editpassword_confirm_new_password: StringResource by lazy {
      StringResource("string:feature_editpassword_confirm_new_password", "feature_editpassword_confirm_new_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 131, 85),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 119, 77),
      ))
    }

internal val Res.string.feature_editpassword_current_password: StringResource by lazy {
      StringResource("string:feature_editpassword_current_password", "feature_editpassword_current_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 217, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 197, 69),
      ))
    }

internal val Res.string.feature_editpassword_error_empty_current_password: StringResource by lazy {
      StringResource("string:feature_editpassword_error_empty_current_password", "feature_editpassword_error_empty_current_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 287, 113),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 267, 105),
      ))
    }

internal val Res.string.feature_editpassword_error_password_min_length: StringResource by lazy {
      StringResource("string:feature_editpassword_error_password_min_length", "feature_editpassword_error_password_min_length", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 401, 122),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 373, 118),
      ))
    }

internal val Res.string.feature_editpassword_error_password_mismatch: StringResource by lazy {
      StringResource("string:feature_editpassword_error_password_mismatch", "feature_editpassword_error_password_mismatch", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 524, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 492, 84),
      ))
    }

internal val Res.string.feature_editpassword_error_password_weak: StringResource by lazy {
      StringResource("string:feature_editpassword_error_password_weak", "feature_editpassword_error_password_weak", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 617, 84),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 577, 72),
      ))
    }

internal val Res.string.feature_editpassword_error_same_password: StringResource by lazy {
      StringResource("string:feature_editpassword_error_same_password", "feature_editpassword_error_same_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 702, 132),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 650, 112),
      ))
    }

internal val Res.string.feature_editpassword_new_password: StringResource by lazy {
      StringResource("string:feature_editpassword_new_password", "feature_editpassword_new_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 835, 65),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 763, 57),
      ))
    }

internal val Res.string.feature_editpassword_old_password: StringResource by lazy {
      StringResource("string:feature_editpassword_old_password", "feature_editpassword_old_password", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 901, 69),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 821, 57),
      ))
    }

internal val Res.string.feature_editpassword_password_changed_successfully: StringResource by lazy {
      StringResource("string:feature_editpassword_password_changed_successfully", "feature_editpassword_password_changed_successfully", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 971, 102),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 879, 98),
      ))
    }

internal val Res.string.feature_editpassword_password_length_error: StringResource by lazy {
      StringResource("string:feature_editpassword_password_length_error", "feature_editpassword_password_length_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1074, 94),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 978, 74),
      ))
    }

internal val Res.string.feature_editpassword_password_mismatch_error: StringResource by lazy {
      StringResource("string:feature_editpassword_password_mismatch_error", "feature_editpassword_password_mismatch_error", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1169, 92),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1053, 76),
      ))
    }

internal val Res.string.feature_editpassword_save: StringResource by lazy {
      StringResource("string:feature_editpassword_save", "feature_editpassword_save", setOf(
        ResourceItem(setOf(LanguageQualifier("es"), ), "${MD}values-es/strings.commonMain.cvr", 1262, 45),
        ResourceItem(setOf(), "${MD}values/strings.commonMain.cvr", 1130, 41),
      ))
    }

@InternalResourceApi
internal fun _collectCommonMainString0Resources(map: MutableMap<String, StringResource>) {
  map.put("feature_editpassword_cancel", Res.string.feature_editpassword_cancel)
  map.put("feature_editpassword_change_password", Res.string.feature_editpassword_change_password)
  map.put("feature_editpassword_confirm_new_password", Res.string.feature_editpassword_confirm_new_password)
  map.put("feature_editpassword_current_password", Res.string.feature_editpassword_current_password)
  map.put("feature_editpassword_error_empty_current_password", Res.string.feature_editpassword_error_empty_current_password)
  map.put("feature_editpassword_error_password_min_length", Res.string.feature_editpassword_error_password_min_length)
  map.put("feature_editpassword_error_password_mismatch", Res.string.feature_editpassword_error_password_mismatch)
  map.put("feature_editpassword_error_password_weak", Res.string.feature_editpassword_error_password_weak)
  map.put("feature_editpassword_error_same_password", Res.string.feature_editpassword_error_same_password)
  map.put("feature_editpassword_new_password", Res.string.feature_editpassword_new_password)
  map.put("feature_editpassword_old_password", Res.string.feature_editpassword_old_password)
  map.put("feature_editpassword_password_changed_successfully", Res.string.feature_editpassword_password_changed_successfully)
  map.put("feature_editpassword_password_length_error", Res.string.feature_editpassword_password_length_error)
  map.put("feature_editpassword_password_mismatch_error", Res.string.feature_editpassword_password_mismatch_error)
  map.put("feature_editpassword_save", Res.string.feature_editpassword_save)
}
